module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-ad16f2a243ad23fe9351fd1ed97eb1c9.png";